import { render, staticRenderFns } from "./Sedes.vue?vue&type=template&id=5c8c85da&scoped=true"
import script from "./Sedes.vue?vue&type=script&lang=js"
export * from "./Sedes.vue?vue&type=script&lang=js"
import style0 from "./Sedes.vue?vue&type=style&index=0&id=5c8c85da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c85da",
  null
  
)

export default component.exports